import React from "react";
import {Card, CardContent, CardHeader, Typography, Button, Stack} from "@mui/material";
import {Cloud, Api, Code} from "@mui/icons-material";
import AuthProvider from "../hooks/authProvider";
import {redirect, useNavigate} from "react-router-dom";
import {showSnackbar} from "../components/snackbarUtils";
import PageTitle from "../components/PageTitle";

export async function loader({request, params}) {
    if (!(await AuthProvider.checkAuth())) {
        const params = new URLSearchParams();
        params.set("from", new URL(request.url).pathname);
        return redirect("/login?" + params.toString());
    }
    return null;
}

export default function TechStackButtons() {
    const navigate = useNavigate();

    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            bgcolor="#f5f5f5"
        >
            <PageTitle title="Документація" />
            <Card sx={{p: 3, maxWidth: 400, boxShadow: 3}}>
                <CardHeader
                    title={<Typography variant="h5" align="center">Project Stack</Typography>}
                />
                <CardContent>
                    <Stack spacing={2}>
                        <Button
                            variant="contained"
                            startIcon={<Cloud/>}
                            fullWidth
                            onClick={() => navigate("/docs-viewer")}>
                            >
                            Django Backend
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<Api/>}
                            fullWidth
                            onClick={() => navigate("/docs-api-viewer")}>
                            >
                            API Resource
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<Code/>}
                            fullWidth
                            onClick={() => navigate("/front-docs-viewer")}>
                            >
                            React Front
                        </Button>
                        <Typography variant="body2" color="textSecondary" align="center" sx={{mt: 2}}>
                            Version: 1.1.170925
                        </Typography>
                    </Stack>
                </CardContent>
            </Card>
        </Stack>
    );
}
